// extracted by mini-css-extract-plugin
module.exports = {"status":"status-2wdel","rejected":"rejected-1kwEH","title":"title-3M3Nq","right":"right-1Ny_B"};